export const DEFAULT_COOKIE_OPTIONS = {
  path: '/',
  sameSite: 'lax',
  secure: true,
  httpOnly: false
} as const

export const ONE_YEAR = 1000 * 60 * 60 * 24 * 365
